import flatten from 'lodash/flatten';
import urlJoin from '@framework/url/helpers/urlJoin';
import baseUrl from '@framework/url/baseUrl';
import domain from '@framework/config/domain';
import config from './index';
import usersUrl from '@users/url';
import dmPortalUrl from '@dm-portal/url';
import appendConsentParams from '@framework/cookie-consent/appendConsentParams';

export default {
  getUrl(uris: Array<string> | string = []) {
    if (!Array.isArray(uris)) {
      uris = [uris];
    }
    uris = flatten(uris).filter((uri) => !!uri);
    return urlJoin(`${ domain.protocol }//${ config.hostname }`, ...uris);
  },

  getRpcUrl(): string {
    return `${ config.api.external }/proxy/api/rpc`;
  },

  getPropagateCallbackUrl(url: string): string {
    return baseUrl.getRestUrl(
      `/propagate?callbackUrl=${ encodeURIComponent(url) }&tenant=${ config.code }`,
    );
  },

  getRegisterUrl(): string {
    return usersUrl.getRegisterUrl(this.getPropagateCallbackUrl(this.getUrl('/')), config.code);
  },

  getLoginUrl(): string {
    return appendConsentParams(usersUrl.getLoginUrl(
      this.getPropagateCallbackUrl(dmPortalUrl.getUrl('/allocate')),
      config.code,
    ));
  },

  getBaseFilesUrl(...uris: (string | string)[]): string {
    return baseUrl.getApiUrl('/allocate/files', ...uris);
  },
};
